import { setPersonInfo } from "../../../app/rootReducer";
import { Dispatch } from "@reduxjs/toolkit";
import { NavigateFunction } from "react-router-dom";
import { RouteEnum } from "../../../common/enums/RouteEnum";
import { setIsTimeoutModalOpen } from "../../LeaveInformationPage/LeaveInformationSlice";

interface Props {
    choice: string;
    dispatch: Dispatch;
    navigate: NavigateFunction;
}

export const handleChoiceSelection = (props: Props): void => {
    const { choice, dispatch, navigate } = props;

    dispatch(
        setPersonInfo({
            choice: choice,
        }),
    );

    dispatch(setIsTimeoutModalOpen(false));
    navigate(RouteEnum.LEAVE_INFORMATION);
};
